import { render, staticRenderFns } from "./LectureSlideCreate.vue?vue&type=template&id=627180a0&"
import script from "./LectureSlideCreate.vue?vue&type=script&lang=ts&"
export * from "./LectureSlideCreate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports